import { FormlyFieldConfig } from "@ngx-formly/core";
import { RichiestaCommercioStep } from "./steps/richiesta-commercio.step";
import { OccupazioneCommercioStep } from "./steps/occupazione-commercio.step";
import { AllegatiCommercioStep } from "./steps/allegati-commercio.step";
import { IntestatarioStep } from "app/forms/shared/intestatario.step";
import { GiuridicaStep } from "app/forms/shared/giuridica.step";
import { PrivacyDelegaStep } from "app/forms/shared/privacy-delega.step";
import { UbicazioneStep } from "../shared/ubicazione.step";
import { IntestatarioTipo } from "app/forms/shared/intestatario.tipo";


export const Commercio:FormlyFieldConfig[] =

 [
        {
            props: {
                slabel: "PRIVACY",
                label: "INFORMATIVA SULLA PRIVACY"
            },
            wrappers: ['panel-step'],
            fieldGroup: PrivacyDelegaStep
        },
        {
            props: {
                slabel: "INTESTATARIO",
                label: "DATI ANAGRAFICI INTESTATARIO"
            },
            wrappers: ['panel-step'],
            fieldGroup: [...IntestatarioTipo, ...IntestatarioStep, ...GiuridicaStep]
        },
        {
            props: {
                slabel: "UBICAZIONE",
                label: "UBICAZIONE DEL CANTIERE IN MAPPA",
            },
            wrappers: ['panel-step'],
            fieldGroup: UbicazioneStep
        },
      {
        props: {
          slabel: 'RICHIESTA',
          label: 'DATI DELLA RICHIESTA'
        },
        wrappers: ['panel-step'],
        fieldGroup: RichiestaCommercioStep
      },
      {
        props: {
          slabel: 'OCCUPAZIONE',
          label: 'ELEMENTI DI OCCUPAZIONE SUOLO PER COMMERCIO'
        },
        wrappers: ['panel-step'],
        fieldGroup: OccupazioneCommercioStep
      },

      {
        props: {
          slabel: 'ALLEGATI',
          label: 'DOCUMENTAZIONE ALLEGATA'
        },
        wrappers: ['panel-step'],
        fieldGroup: AllegatiCommercioStep
      },
    ]


